export const inboxConstants = {
  GET_ORG_INBOX_MESSAGES_REQUEST: "GET_ORG_INBOX_MESSAGES_REQUEST",
  GET_ORG_INBOX_MESSAGES_SUCCESS: "GET_ORG_INBOX_MESSAGES_SUCCESS",
  GET_ORG_INBOX_MESSAGES_FAILURE: "GET_RG_INBOX_MESSAGES_FAILURE",

  GET_PARENT_POST_REQUEST: "GET_PARENT_POST_REQUEST",
  GET_PARENT_POST_SUCCESS: "GET_PARENT_POST_SUCCESS",
  GET_PARENT_POST_FAILURE: "GET_PARENT_POST_FAILURE",

  LOCK_MESSAGE_REQUEST: "LOCK_INBOX_MESSAGE_REQUEST",
  LOCK_MESSAGE_SUCCESS: "LOCK_INBOX_MESSAGE_SUCCESS",
  LOCK_MESSAGE_FAILURE: "LOCK_INBOX_MESSAGE_FAILURE",

  REGENERATE_REPLY_REQUEST: "REGENERATE_REPLY_REQUEST",
  REGENERATE_REPLY_SUCCESS: "REGENERATE_REPLY_SUCCESS",
  REGENERATE_REPLY_FAILURE: "REGENERATE_REPLY_FAILURE",
};
